type TableLoadingProps = {
  text?: string;
  subtext?: string;
};

function TableLoadingCard({ text = '加载中...', subtext = '' }: TableLoadingProps) {
  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 10,
        minWidth: 112,
        padding: '9px 12px',
        borderRadius: 'var(--radius-sm)',
        background: 'var(--surface)',
        boxShadow: 'var(--shadow)',
      }}
    >
      <span
        style={{
          width: 18,
          height: 18,
          flex: '0 0 auto',
          borderRadius: '50%',
          border: '2px solid var(--border2)',
          borderTopColor: 'var(--primary)',
          animation: 'spin .8s linear infinite',
        }}
      />
      <span style={{ display: 'inline-flex', flexDirection: 'column', gap: 2 }}>
        <span style={{ color: 'var(--text)', fontSize: 12, fontWeight: 500, lineHeight: 1.25 }}>{text}</span>
        {subtext && <span style={{ color: 'var(--text3)', fontSize: 11, lineHeight: 1.25 }}>{subtext}</span>}
      </span>
    </div>
  );
}

export function TableLoadingState({ text, subtext }: TableLoadingProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 96, padding: 24 }}>
      <TableLoadingCard text={text} subtext={subtext} />
    </div>
  );
}

export function TableLoadingCell({ text, subtext }: TableLoadingProps) {
  return (
    <div style={{ minHeight: 96, padding: 24, position: 'relative' }}>
      <div
        style={{
          position: 'sticky',
          left: '50%',
          width: 'max-content',
          transform: 'translateX(-50%)',
        }}
      >
        <TableLoadingCard text={text} subtext={subtext} />
      </div>
    </div>
  );
}

export function TableLoadingOverlay({ text, subtext }: TableLoadingProps) {
  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        zIndex: 5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'none',
        background: 'color-mix(in srgb, var(--surface) 78%, transparent)',
        backdropFilter: 'blur(2px)',
      }}
    >
      <TableLoadingCard text={text} subtext={subtext} />
    </div>
  );
}
